import DateFnsUtils from "@date-io/date-fns";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import {default as AllInboxIcon} from "@material-ui/icons/AllInbox";
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import BarChartIcon from '@material-ui/icons/BarChart';
import DateRangeIcon from "@material-ui/icons/DateRange";
import EditLocationIcon from "@material-ui/icons/EditLocation";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import HomeIcon from '@material-ui/icons/Home';
import HomeWorkIcon from '@material-ui/icons/HomeWork';
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import ListAltIcon from '@material-ui/icons/ListAlt';
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import MapIcon from "@material-ui/icons/Map";
import MoneyOffIcon from "@material-ui/icons/MoneyOff";
import MoreIcon from "@material-ui/icons/More";
import PermContactCalendarIcon from "@material-ui/icons/PermContactCalendar";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";
import PublishIcon from "@material-ui/icons/Publish";
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import ReceiptIcon from "@material-ui/icons/Receipt";
import SelectAllIcon from '@material-ui/icons/SelectAll';
import SettingsIcon from '@material-ui/icons/Settings';
import StoreIcon from "@material-ui/icons/Store";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import SystemUpdateAltIcon from "@material-ui/icons/SystemUpdateAlt";
import TimelineIcon from "@material-ui/icons/Timeline";
import TocIcon from "@material-ui/icons/Toc";
import TuneIcon from '@material-ui/icons/Tune';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import {MuiPickersUtilsProvider} from "@material-ui/pickers";
import it from "date-fns/locale/it";
import {createBrowserHistory} from "history";
import "leaflet-draw/dist/leaflet.draw-src.css";
import polyglotI18nProvider from "ra-i18n-polyglot";
import italianMessages from "ra-language-italian";
import {Admin, Resource} from "react-admin";
import {QueryClient, QueryClientProvider} from "react-query";
import {ReactQueryDevtools} from "react-query/devtools";
import {Route} from "react-router-dom";
import "./App.css";
import jwtTokenAuthProvider, {getUser} from "./authProvider";
import {DeliveryMergerList} from "./BusinessIntelligence/DeliveryMerger/DeliveryMergerList";
import {RouteSummaryList} from "./BusinessIntelligence/RouteSummary/RouteSummaryList";
import {CarrierCashBoxList} from "./CarriersPortal/CarrierCashBox/CarrierCashBoxList";
import {CarrierDeliveryList} from "./CarriersPortal/CarrierDelivery/CarrierDeliveryList";
import {UserCarrierCreate} from "./CarriersPortal/UserCarrier/UserCarrierCreate";
import {UserCarrierEdit} from "./CarriersPortal/UserCarrier/UserCarrierEdit";
import {UserCarrierList} from "./CarriersPortal/UserCarrier/UserCarrierList";
import {CalculateChargesList} from "./Charges/CalculateChargesList/CalculateChargesList";
import {CalculatePurchaseChargesList} from "./Charges/CalculateChargesList/CalculatePurchaseChargesList";
import {ChargeEdit} from "./Charges/ChargeEdit";
import {ChargesSummaryList} from "./Charges/ChargeSummary/ChargesSummaryList";
import {PurchaseChargesSummaryList} from "./Charges/ChargeSummary/PurchaseChargesSummaryList";
import {VerifiedChargesSummaryList} from "./Charges/ChargeSummary/VerifiedChargesSummaryList";
import {VerifiedPurchaseChargesSummaryList} from "./Charges/ChargeSummary/VerifiedPurchaseChargesSummaryList";
import {PurchaseChargeEdit} from "./Charges/PurchaseChargeEdit";
import {VerifiedChargesList} from "./Charges/VerifiedChargesList/VerifiedChargesList";
import {VerifiedPurchaseChargesList} from "./Charges/VerifiedChargesList/VerifiedPurchaseChargesList";
import {ChartAccountsCreate} from "./ChartAccounts/ChartAccounts/ChartAccountsCreate";
import {ChartAccountsEdit} from "./ChartAccounts/ChartAccounts/ChartAccountsEdit";
import {ChartAccountsList} from "./ChartAccounts/ChartAccounts/ChartAccountsList";
import {ChartAccountsTagsCreate} from "./ChartAccounts/ChartAccountsTag/ChartAccountsTagsCreate";
import {ChartAccountsTagsEdit} from "./ChartAccounts/ChartAccountsTag/ChartAccountsTagsEdit";
import {ChartAccountsTagsList} from "./ChartAccounts/ChartAccountsTag/ChartAccountsTagsList";
import {ChartAccountsTreePage} from "./ChartAccounts/ChartAccountsTree";
import {InvoiceChartAccountsGroupedList} from "./ChartAccounts/InvoiceChartAccounts/InvoiceChartAccountsGroupedList";
import {CustomLayout} from "./components/CustomLayout";
import {DownloadCustomerImportTemplate} from "./components/DownloadCustomerImportTemplate";
import {DownloadSupersonicaImportTemplate} from "./components/DownloadSupersonicaImportTemplate";
import {url} from "./constants";
import {CustomerDeliveryList} from "./CustomersPortal/CustomerDelivery/CustomerDeliveryList";
import {CustomerImportFileCreate} from "./CustomersPortal/CustomerImportFile/CustomerImportFileCreate";
import {CustomerImportFileList} from "./CustomersPortal/CustomerImportFile/CustomerImportFileList";
import {CustomerOrderCreate} from "./CustomersPortal/CustomerOrder/CustomerOrderCreate";
import {CustomerOrderEdit} from "./CustomersPortal/CustomerOrder/CustomerOrderEdit";
import {CustomerOrderList} from "./CustomersPortal/CustomerOrder/CustomerOrderList";
import {CustomerSubjectCreate} from "./CustomersPortal/CustomerSubject/CustomerSubjectCreate";
import {CustomerSubjectEdit} from "./CustomersPortal/CustomerSubject/CustomerSubjectEdit";
import {CustomerSubjectList} from "./CustomersPortal/CustomerSubject/CustomerSubjectList";
import {UserClientCreate} from "./CustomersPortal/UserClient/UserClientCreate";
import {UserClientEdit} from "./CustomersPortal/UserClient/UserClientEdit";
import {UserClientList} from "./CustomersPortal/UserClient/UserClientList";
import drfProvider from "./dataProvider";
import {CachetBoxList} from "./Distribution/Cachet/CachetBoxList";
import {CachetEdit} from "./Distribution/Cachet/CachetEdit";
import {CachetPaymentList} from "./Distribution/Cachet/CachetPayment/CachetPaymentList";
import {CachetToCashInList} from "./Distribution/Cachet/CachetToCashInList";
import {DeliveryCreate} from "./Distribution/Delivery/DeliveryCreate";
import {DeliveryEdit} from "./Distribution/Delivery/DeliveryEdit";
import {DeliveryList} from "./Distribution/Delivery/DeliveryList";
import {EtaConfigPage} from "./Distribution/Config/EtaConfigPage";
import {DeliveryGroupEdit} from "./Distribution/DeliveryGroup/DeliveryGroupEdit";
import {DeliveryGroupList} from "./Distribution/DeliveryGroup/DeliveryGroupList";
import {DeliveryZoneEdit} from "./Distribution/DeliveryZone/DeliveryZoneEdit";
import {DeliveryZoneList} from "./Distribution/DeliveryZone/DeliveryZoneList";
import {NotAssignedNotes} from "./Distribution/Note/NotAssignedNotes";
import {NoteCreate} from "./Distribution/Note/NoteCreate";
import {NoteEdit} from "./Distribution/Note/NoteEdit";
import {NoteList} from "./Distribution/Note/NoteList";
import {NoteConfigurationCreate} from "./Distribution/NoteConfiguration/NoteConfigurationCreate";
import {NoteConfigurationEdit} from "./Distribution/NoteConfiguration/NoteConfigurationEdit";
import {NoteConfigurationList} from "./Distribution/NoteConfiguration/NoteConfigurationList";
import {NoteImportList} from "./Distribution/NoteImport/NoteImportList";
import {RemittanceEdit} from "./Distribution/Remittance/RemittanceEdit";
import {RemittanceList} from "./Distribution/Remittance/RemittanceList";
import {RouteEdit} from "./Distribution/Route/RouteEdit";
import {RouteList} from "./Distribution/Route/RouteList";
import {EmailList} from "./Emails/EmailList";
import {EmployeeCreate} from "./Employees/EmployeeCreate";
import {EmployeeEdit} from "./Employees/EmployeeEdit";
import {EmployeeList} from "./Employees/EmployeeList";
import {FileUploadCreate} from "./FileUpload/FileUploadCreate";
import {FileUploadList} from "./FileUpload/FileUploadList";
import {FirstPage} from "./FirstPage";
import {ForkliftList} from "./Forklift/ForkliftList";
import {BadgeCreate} from "./HR/Badge/BadgeCreate";
import {BadgeEdit} from "./HR/Badge/BadgeEdit";
import {BadgeList} from "./HR/Badge/BadgeList";
import {PresenceCalendar} from "./HR/Presence/PresenceCalendar";
import {PresenceCreate} from "./HR/Presence/PresenceCreate";
import {PresenceDayList} from "./HR/Presence/PresenceDayList";
import {PresenceEdit} from "./HR/Presence/PresenceEdit";
import {PresenceList} from "./HR/Presence/PresenceList";
import {PresenceOnlyInList} from "./HR/Presence/PresenceOnlyInList";
import {PresenceSummary} from "./HR/Presence/PresenceSummary";
import {PresenceQrCreate} from "./HR/PresenceQr/PresenceQrCreate";
import {PresenceQrEdit} from "./HR/PresenceQr/PresenceQrEdit";
import {PresenceQrGeneratorPage} from "./HR/PresenceQr/PresenceQrGeneratorPage";
import {PresenceQrList} from "./HR/PresenceQr/PresenceQrList";
import {PresenceZoneEdit} from "./HR/PresenceZone/PresenceZoneEdit";
import {PresenceZoneList} from "./HR/PresenceZone/PresenceZoneList";
import {ShiftsMakerPage} from "./HR/Shifts/ShiftsMakerPage";
import {WorkPermitCreate} from "./HR/WorkPermit/WorkPermitCreate";
import {WorkPermitEdit} from "./HR/WorkPermit/WorkPermitEdit";
import {WorkPermitList} from "./HR/WorkPermit/WorkPermitList";
import {WorkPermitRuleCreate} from "./HR/WorkPermit/WorkPermitRuleCreate";
import {WorkPermitRuleEdit} from "./HR/WorkPermit/WorkPermitRuleEdit";
import {WorkPermitRuleList} from "./HR/WorkPermit/WorkPermitRuleList";
import {WorkPermitTotalsList} from "./HR/WorkPermit/WorkPermitTotalsList";
import {ImportList} from "./Import/ImportList";
import {InvoiceShow} from "./Invoices/components/InvoiceShow";
import {InvoiceCreate} from "./Invoices/InvoiceCreate/InvoiceCreate";
import {PurchaseInvoiceCreate} from "./Invoices/InvoiceCreate/PurchaseInvoiceCreate";
import {InvoiceEdit} from "./Invoices/InvoiceEdit/InvoiceEdit";
import {InvoiceList} from "./Invoices/InvoiceList";
import {PurchaseInvoiceList} from "./Invoices/PurchaseInvoiceList";
import {XMLFileUploadCreate} from "./Invoices/XMLFileUpload/XMLFileUploadCreate";
import {XMLFileUploadList} from "./Invoices/XMLFileUpload/XMLFileUploadList";
import {CategoryCreate} from "./Items/CategoryCreate";
import {CategoryEdit} from "./Items/CategoryEdit";
import {CategoryList} from "./Items/CategoryList";
import {ItemCreate} from "./Items/ItemCreate";
import {ItemEdit} from "./Items/ItemEdit";
import {ItemList} from "./Items/ItemList";
import {ReasonStatusCreate} from "./Items/ReasonStatus/ReasonStatusCreate";
import {ReasonStatusEdit} from "./Items/ReasonStatus/ReasonStatusEdit";
import {ReasonStatusList} from "./Items/ReasonStatus/ReasonStatusList";
import {TariffCreate} from "./Items/Tariff/TariffCreate";
import {TariffEdit} from "./Items/Tariff/TariffEdit";
import {TariffList} from "./Items/Tariff/TariffList";
import {PermissionInfoPage} from "./PermissionInfo";
import {QrScanner} from "./QrScanner";
import {RoutePlannerPage} from "./RoutePlanner";
import {SiteCreate} from "./Sites/SiteCreate";
import {SiteEdit} from "./Sites/SiteEdit";
import {SiteList} from "./Sites/SiteList";
import {SplitSegmentList} from "./SplitSegments/SplitSegmentList";
import {SubjectCreate} from "./Subjects/SubjectCreate";
import {SubjectEdit} from "./Subjects/SubjectEdit";
import {SubjectList} from "./Subjects/SubjectList";
import {SubjectSolverList} from "./SubjectsSolver/SubjectsSolverList";
import {VehicleCreate} from "./Vehicles/VehicleCreate";
import {VehicleEdit} from "./Vehicles/VehicleEdit";
import {VehicleList} from "./Vehicles/VehicleList";
import {BoardRoutes} from "./Warehouse/BoardRoutes/BoardRoutes";
import {LoadDeliveriesList} from "./Warehouse/LoadDelivery/LoadDeliveriesList";
import {LoadRouteEdit} from "./Warehouse/LoadRoute/LoadRouteEdit";
import {LoadRouteList} from "./Warehouse/LoadRoute/LoadRouteList";
import {RouteMonitorList} from "./Warehouse/RouteMonitor/RouteMonitorList";
import {RouteScanner} from "./RouteScanner";
import {InfoPage} from "./InfoPage";
import {
    TbRouteScan,
    TbCalendarWeekFilled,
    TbCashRegister,
    TbFileTypeXml,
    TbListLetters,
    TbMapUp,
    TbPackages,
    TbReportMoney
} from "react-icons/tb";
import {
    BsCalendar2Week,
    BsUiChecks,
    BsQrCode,
    BsInfoCircle,
    BsJournalPlus,
    BsJournalMinus,
    BsPersonVideo2,
    BsPersonWorkspace, BsStars,
} from "react-icons/bs";
import {PiListChecksBold, PiTableLight} from "react-icons/pi";
import {
    FaFileImport,
    FaFileInvoice,
    FaFileInvoiceDollar,
    FaRegHandshake, FaRegUser, FaTags,
    FaTruckLoading,
    FaUmbrellaBeach
} from "react-icons/fa";
import {GiFamilyTree, GiGps, GiReceiveMoney} from "react-icons/gi";
import {
    FaMoneyBillTransfer,
    FaMoneyCheckDollar,
    FaPeopleCarryBox,
    FaPersonChalkboard,
    FaUserLargeSlash
} from "react-icons/fa6";
import {LuFolderTree, LuMonitorCheck, LuPackageCheck, LuTableColumnsSplit} from "react-icons/lu";
import {GrConfigure} from "react-icons/gr";
import {BiQrScan} from "react-icons/bi";
import {
    MdDomainVerification,
    MdForklift,
    MdOutlineAccountBalance,
    MdOutlineBadge,
    MdOutlineCategory,
    MdOutlineMailOutline,
    MdPayments,
} from "react-icons/md";
import {TfiAgenda} from "react-icons/tfi";
import {GoCodescanCheckmark} from "react-icons/go";
import {CheckCounter} from "./Charges/CheckCounter";
import {JournalEntryList} from "./ChartAccounts/JournalEntrny/JournalEntryList";
import {JournalEntryCreate} from "./ChartAccounts/JournalEntrny/JournalEntryCreate";
import {JournalEntryEdit} from "./ChartAccounts/JournalEntrny/JournalEntryEdit";
import {ReconciliationFileList} from "./ChartAccounts/ReconciliationFile/ReconciliationFileList";
import {ReconciliationFileCreate} from "./ChartAccounts/ReconciliationFile/ReconciliationFileCreate";
import {ReconciliationList} from "./ChartAccounts/Reconciliation/ReconciliationList";
import {BankReceiptList} from "./ChartAccounts/BankReceipt/BankReceiptList";
import {BankReceiptCreate} from "./ChartAccounts/BankReceipt/BankReceiptCreate";
import {PaymentScheduleList} from "./ChartAccounts/PaymentSchedule/PaymentScheduleList";
import {DebtColletionList} from "./ChartAccounts/DebtCollection/DebtColletionList";
import {IoDocuments} from "react-icons/io5";
import {DocumentList} from "./Invoices/Document/DocumentList";
import {DocumentCreate} from "./Invoices/Document/DocumentCreate";
import {IoIosTimer} from "react-icons/io";
import {DebtColletionShow} from "./ChartAccounts/DebtCollection/DebtColletionShow";
import {ApprovedInvoicesList} from "./Invoices/ApprovedInvoices/ApprovedInvoicesList";
import {BankReceiptEdit} from "./ChartAccounts/BankReceipt/BankReceiptEdit";
import {DocumentEdit} from "./Invoices/Document/DocumentEdit";
import {WorkPermitTypeList} from "./HR/WorkPermitType/WorkPermitTypeList";
import {WorkPermitTypeCreate} from "./HR/WorkPermitType/WorkPermitTypeCreate";
import {WorkPermitTypeEdit} from "./HR/WorkPermitType/WorkPermitTypeEdit";
import {
    DeliveryAdministrativeBlockList
} from "./Distribution/DeliveryAdministrativeBlock/DeliveryAdministrativeBlockList";
import {CarrierRouteList} from "./CarriersPortal/CarrierRoute/CarrierRouteList";
import {UsersList} from "./Users/UsersList";
import {UserCreate} from "./Users/UserCreate";
import {UserEdit} from "./Users/UserEdit";
import {TagList} from "./Tag/TagList";
import {TagCreate} from "./Tag/TagCreate";
import {TagEdit} from "./Tag/TagEdit";
import {NotificationChatIdList} from "./NotificationChatId/NotificationChatIdList";
import {IoChatbubbleEllipsesSharp} from "react-icons/io5";
import {NotificationChatIdEdit} from "./NotificationChatId/NotificationChatIdEdit";
import {WorkPermitCalendar} from "./HR/WorkPermitCalendar/WorkPermitCalendar";
import {MdSummarize} from "react-icons/md";
import PageSummaryOfTheDay from "./Warehouse/SummaryOfTheDay/PageSummaryOfTheDay";
import {hasPermission} from "./authProvider"
import {CarrierBorderauxList} from "./CarriersPortal/CarrierRoute/CarrierBorderauxList";
import {IoIosListBox} from "react-icons/io";
import {MdBlock} from "react-icons/md";
import {MissingSubjectList} from "./Import/MissingSubjectList";
import {PaymentScheduleEdit} from "./ChartAccounts/PaymentSchedule/PaymentScheduleEdit";
import {PaymentScheduleStatusEdit} from "./ChartAccounts/PaymentSchedule/PaymentScheduleStatusEdit";
import {ImportFunctionList} from "./Import/ImportFunction/ImportFunctionList";
import {ImportFunctionCreate} from "./Import/ImportFunction/ImportFunctionCreate";
import {ImportFunctionEdit} from "./Import/ImportFunction/ImportFunctionEdit";
import {RiFileSettingsLine} from "react-icons/ri";
import {NoteConvertPage} from "./Be20AI/NoteConvert/NoteConvertPage";
import {AiChargeDashboard} from "./Be20AI/AiCharge/AiChargeDashboard";


const iconSize = 23;
const iconColor = "#f44336";

const i18nProvider = polyglotI18nProvider(
    () => ({
        ...italianMessages,
        ra: {
            ...italianMessages.ra,
            message: {
                ...italianMessages.ra.message,
                bulk_update_title:
                    "Modifica %{name} |||| Modifica %{smart_count} %{name} oggetti",
                bulk_update_content:
                    "Sei sicuro di voler modificare questo %{name}? |||| Sei sicuro di voler modificare questi %{smart_count}?",
                bulk_delete_title:
                    'Cancella %{name} |||| Cancella %{smart_count} %{name}',
                delete_content: 'Sicuro di volerlo cancellare?',
                error:
                    "Attenzione si è verificato un errore, se l'errore persiste contattare l'amministratore del sistema",
            },
            action: {
                ...italianMessages.ra.action,
                add_filter: 'Filtri',
                create_item: "Nuovo",
            },
        },
        resources: {
            charges: {name: "Addebito |||| Addebiti"},
        },
    }),
    "it",
    {
        allowMissing: true,
    }
);
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});
const history = createBrowserHistory();

function App() {
    const authProvider = jwtTokenAuthProvider({
        obtainAuthTokenUrl: `${url}/token/`,
    });
    const dataProvider = drfProvider(url);
    const customRoutes = [
        <Route exact path="/notes/not-assigned" component={NotAssignedNotes}/>,
    ];

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={it}>
            <QueryClientProvider client={queryClient}>
                <ReactQueryDevtools initialIsOpen={false}/>

                <Admin
                    customRoutes={customRoutes}
                    layout={CustomLayout}
                    history={history}
                    theme={{
                        typography: {
                            fontFamily: `"Inter", "Public Sans", "Helvetica", "Arial", sans-serif`,

                            fontWeightLight: 300,
                            fontWeightRegular: 400,
                            fontWeightMedium: 500,
                        },
                        palette: {
                            primary: {
                                main: "#f44336",
                                light: "#f443362b",
                                dark: "#ba000d",
                                contrastText: "#000000",
                            },
                            secondary: {
                                light: "#484848",
                                main: "#212121",
                                dark: "#000000",
                                contrastText: "#ffffff",
                            },

                            type: "light" as "light",
                        },
                        shape: {
                            borderRadius: 7,
                        },
                        sidebar: {width: 200},
                        overrides: {
                            //@ts-ignore
                            RaMenuItemLink: {
                                root: {
                                    minHeight: "26px",
                                    paddingLeft: "8px",
                                    paddingRight: "8px",
                                    paddingTop: "2px",
                                    paddingBottom: "6px",
                                },
                                active: {
                                    borderRight: "3px solid #f44336",
                                    color: "#f44336",
                                    background: "#f443362b",
                                },
                                icon: {
                                    color: "inherit",
                                    minWidth: "34px",
                                },
                            },

                            MuiMenuItem: {
                                root: {
                                    paddingTop: "12px",
                                    paddingBottom: "12px",
                                    fontWeight: 600,
                                    fontSize: "0.875rem",
                                },
                            },
                            RaSidebar: {
                                root: {
                                    height: "100vh",
                                },
                                fixed: {
                                    height: "100vh",
                                },
                            },
                            RaDatagrid: {
                                headerCell: {
                                    backgroundColor: "#fde2e0",
                                    height: "40px",
                                    fontWeight: 550,
                                    whiteSpace: "nowrap",
                                    top: window.location.pathname.includes("invoices-time-table")
                                        ? 80
                                        : (window.location.pathname === "/deliveries"
                                            ? 40
                                            : 0),
                                    "&&:first-child": {
                                        borderTopLeftRadius: "0px",
                                    },
                                    "&&:last-child": {
                                        borderTopRightRadius: "0px",
                                    },
                                },
                            },
                            MuiTableCell: {
                                sizeSmall: {padding: "0px 5px 0px 5px"},
                                root: {fontSize: "0.85rem", whiteSpace: "nowrap"},
                            },
                            MuiPaper: {rounded: {borderRadius: "0px"}},

                            MuiButton: {
                                text: {textTransform: "none", fontWeight: 600},
                                contained: {
                                    backgroundColor: "#fff",
                                    color: "#4f3cc9",
                                    boxShadow: "none",
                                },
                            },

                            MuiButtonBase: {
                                root: {
                                    "&:hover:active::after": {
                                        // recreate a static ripple color
                                        // use the currentColor to make it work both for outlined and contained buttons
                                        // but to dim the background without dimming the text,
                                        // put another element on top with a limited opacity
                                        content: '""',
                                        display: "block",
                                        width: "100%",
                                        height: "100%",
                                        position: "absolute",
                                        top: 0,
                                        right: 0,
                                        backgroundColor: "currentColor",
                                        opacity: 0.3,
                                        borderRadius: "inherit",
                                    },
                                },
                            },
                            MuiAppBar: {
                                root: {
                                    boxShadow: "none",
                                    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                                },
                                colorSecondary: {backgroundColor: "white", color: "primary"},
                            },

                            RaBulkActionsToolbar: {
                                toolbar: {
                                    minHeight: "20px",
                                    height: "25px",
                                    position: "fixed",
                                    backgroundColor: "lightgreen",
                                    left: "15%",
                                    right: "5%",
                                    top: "0px",
                                    zIndex: 9999999,
                                }
                            },


                            MuiLinearProgress: {
                                colorPrimary: {
                                    backgroundColor: "#f5f5f5",
                                },
                                barColorPrimary: {
                                    backgroundColor: "#d7d7d7",
                                },
                            },
                            MuiFilledInput: {
                                root: {
                                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                                    "&$disabled": {
                                        backgroundColor: "rgba(0, 0, 0, 0.04)",
                                    },
                                },
                            },
                        },
                        props: {
                            MuiButtonBase: {
                                // disable ripple for perf reasons
                                disableRipple: true,
                            },
                        },
                    }}
                    authProvider={authProvider}
                    dataProvider={dataProvider}
                    i18nProvider={i18nProvider}
                >
                    {
                        (permissions) => {
                            const user = getUser();
                            // se il profilo non è ancora pronto, non crashare
                            if (!user) return [];
                            const isCarrier = user?.is_carrier === true;
                            const isAdmin = user?.is_admin === true;


                            if (isCarrier) {
                                return [
                                    <Resource
                                        icon={HomeIcon}
                                        options={{label: "Homepage"}}
                                        name="home"
                                        list={FirstPage}/>,

                                    hasPermission(permissions, 'distribution.change_note') ? (
                                        <Resource
                                            icon={() => <BsQrCode size={iconSize - 2}/>}
                                            options={{label: "WebScanner"}}
                                            name="qr_scanner"
                                            list={QrScanner}/>) : null,

                                    hasPermission(permissions, 'distribution.change_note') ? (
                                        <Resource
                                            icon={() => <TbRouteScan size={iconSize}/>}
                                            options={{label: "Avvia giro"}}
                                            name="start_route"
                                            list={RouteScanner}/>) : null,
                                    hasPermission(permissions, 'distribution.change_note') ? (
                                        <Resource name="/routes/qr_code_start_route/"/>) : null,

                                    hasPermission(permissions, 'be20_ai.view_convertnote') ? (
                                        <Resource
                                            name="ai_charges"
                                            list={AiChargeDashboard}
                                            options={{label: "Dashboard AI"}}
                                            icon={BarChartIcon}/>) : null,

                                    // ----------------  REGISTRY
                                    hasPermission(permissions, 'registry.view_site') ? (
                                        <Resource
                                            name="sites"/>) : null,
                                    hasPermission(permissions, 'employees.view_employee') ? (
                                        <Resource name="employees"/>
                                    ) : null,

                                    hasPermission(permissions, 'fleet_management.view_vehicle') ? (
                                        <Resource name="vehicles"/>) : null,

                                    hasPermission(permissions, 'registry.view_subject') ? (
                                        <Resource name="subjects"/>) : null,

                                    // ----------------  DISTRIBUTION
                                    isAdmin ||
                                    hasPermission(permissions, 'distribution.view_delivery') ||
                                    hasPermission(permissions, 'distribution.view_stock') ||
                                    (hasPermission(permissions, 'route_management.change_route') && hasPermission(permissions, 'distribution.view_segment')) ||
                                    (hasPermission(permissions, 'distribution.view_route') && hasPermission(permissions, 'distribution.view_segment')) ||
                                    hasPermission(permissions, 'distribution.view_deliveryzone') ||
                                    hasPermission(permissions, 'distribution.view_note') ? (
                                        <Resource
                                            options={{label: "Distribuzione", isMenuParent: true}}
                                            name="distribution"
                                            icon={SystemUpdateAltIcon}
                                        />) : null,

                                    hasPermission(permissions, 'distribution.view_delivery') ? (
                                        <Resource
                                            name="deliveries"
                                            list={DeliveryList}
                                            edit={DeliveryEdit}
                                            create={DeliveryCreate}
                                            icon={() => <BsUiChecks size={iconSize}/>}
                                            options={{label: "Missioni", menuParent: "distribution"}}/>) : null,

                                    hasPermission(permissions, 'route_management.change_route') ? (
                                        <Resource
                                            name="planner"
                                            list={RoutePlannerPage}
                                            options={{label: "Pianificatore", menuParent: "distribution"}}
                                            icon={MapIcon}/>) : null,

                                    hasPermission(permissions, 'distribution.view_route') ? (
                                        <Resource
                                            name="routes"
                                        />) : null,
                                    hasPermission(permissions, 'distribution.view_splitsegment') ? (
                                        <Resource name="split-segments"/>) : null,

                                    hasPermission(permissions, 'distribution.view_deliveryzone') ? (
                                        <Resource name="delivery-zones"/>) : null,


                                    hasPermission(permissions, 'route_management.change_route') && hasPermission(permissions, 'distribution.change_delivery') ? (
                                        <Resource name="autocomplete/delivery-group"/>) : null,

                                    // ----------------  CARRIER PORTAL
                                    hasPermission(permissions, 'base.view_carrierdelivery') || hasPermission(permissions, 'auth.view_user') ? (
                                        <Resource
                                            options={{label: "Portale Corrieri", isMenuParent: true}}
                                            name="carrier_portal"
                                            icon={() => <FaPeopleCarryBox size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'base.view_carrierdelivery') ? (
                                        <Resource
                                            name="carrier_deliveries"
                                            list={CarrierDeliveryList}
                                            options={{label: "Missioni", menuParent: "carrier_portal"}}
                                            icon={() => <BsUiChecks size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'base.view_carrierdelivery') ? (
                                        <Resource
                                            name="carrier_borderaux"
                                            list={CarrierBorderauxList}
                                            options={{label: "Borderaux", menuParent: "carrier_portal"}}
                                            icon={() => <IoIosListBox size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'base.view_carrierdelivery') ? (
                                        <Resource
                                            name="carrier_routes"
                                            list={CarrierRouteList}
                                            options={{label: "Giri", menuParent: "carrier_portal"}}
                                            icon={() => <IoIosListBox size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'carriers.view_carriercashbox') ? (
                                        <Resource
                                            name="carrier_cashboxes"
                                            list={CarrierCashBoxList}
                                            options={{label: "Casse", menuParent: "carrier_portal"}}
                                            icon={() => <TbCashRegister size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'auth.view_user') ? (
                                        <Resource
                                            name="user_carriers"
                                            list={UserCarrierList}
                                            create={UserCarrierCreate}
                                            edit={UserCarrierEdit}
                                            options={{label: "Utenti", menuParent: "carrier_portal"}}
                                            icon={() => <FaRegUser size={iconSize}/>}/>) : null,

                                    // ----------------  WAREHOUSE
                                    hasPermission(permissions, 'base.view_carrierdelivery') ? (
                                        <Resource
                                            options={{label: "Magazzino", isMenuParent: true}}
                                            name="warehouse"
                                            icon={HomeWorkIcon}/>) : null,

                                    hasPermission(permissions, 'base.view_carrierdelivery') ? (
                                        <Resource
                                            name="load-routes"
                                            list={LoadRouteList}
                                            edit={LoadRouteEdit}
                                            options={{label: "Carica giri", menuParent: "warehouse"}}
                                            icon={() => <FaTruckLoading size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'base.view_carrierdelivery') ? (
                                        <Resource
                                            name="load-deliveries"
                                            list={LoadDeliveriesList}
                                            icon={() => <LuPackageCheck size={iconSize}/>}
                                            options={{label: "Carica missioni", menuParent: "warehouse"}}/>) : null,

                                    // -------- READ ONLY API
                                    // TODO: Ricordarsi di inserire dei permessi più robusti
                                    hasPermission(permissions, 'route_management.change_route') ? (
                                        <Resource name="route_maps"/>) : null,
                                    hasPermission(permissions, 'distribution.view_deliveryattachment') ? (
                                        <Resource name="delivery_attachments"/>) : null,
                                    hasPermission(permissions, 'registry.view_subjectattachment') ? (
                                        <Resource name="subject_attachments"/>) : null,
                                    <Resource name="delivery-items"/>,
                                    <Resource name="delivery-note-rows"/>,
                                    <Resource name="invoice-lines"/>,
                                    <Resource name="clients"/>,
                                    <Resource name="deliveries-plan"/>,
                                    <Resource name="segments"/>,
                                    <Resource name="payment-terms"/>,
                                    //<Resource name="invoice-payment-status" />,
                                    <Resource name="delivery-states"/>,
                                    <Resource name="provinces"/>,
                                    <Resource name="sub-tariffs"/>,
                                    <Resource name="notifications"/>,
                                    <Resource name="subjectopenings"/>,


                                    <Resource name="autocomplete/user"/>,
                                    <Resource name="autocomplete/delivery"/>,
                                    <Resource name="autocomplete/main_delivery"/>,
                                    <Resource name="autocomplete/subject"/>,
                                    <Resource name="autocomplete/user"/>,
                                    <Resource name="autocomplete/terms-payment"/>,
                                    <Resource name="autocomplete/terms-description"/>,
                                    <Resource name="autocomplete/route"/>,
                                    <Resource name="autocomplete/employee"/>,
                                    <Resource name="autocomplete/vehicle"/>,
                                    <Resource name="autocomplete/site"/>,
                                    <Resource name="autocomplete/imported-files"/>,
                                    <Resource name="autocomplete/delivery-zones"/>,
                                    <Resource name="autocomplete/province"/>,
                                    <Resource name="autocomplete/region"/>,
                                    <Resource name="autocomplete/province-region"/>,
                                    <Resource name="autocomplete/category"/>,
                                    <Resource name="autocomplete/item"/>,
                                    <Resource name="autocomplete/tag"/>,
                                    <Resource name="autocomplete/department"/>,
                                    <Resource name="autocomplete/invoice"/>,
                                    <Resource name="autocomplete/bank"/>,
                                    <Resource name="autocomplete/remittances"/>,
                                    <Resource name="autocomplete/accountcompany"/>,
                                    <Resource name="tariffs-client"/>,
                                    <Resource name="customer_order_tariffs"/>,
                                    <Resource name="customer_order_items"/>,
                                    <Resource name="tariffs-clone-option"/>,
                                    <Resource name="autocomplete/chartaccounts"/>,
                                    <Resource name="autocomplete/workpermittype"/>,
                                    <Resource name="autocomplete/workpermittypeemployee"/>,
                                    <Resource name="autocomplete/refusereason"/>,
                                    <Resource name="autocomplete/group"/>,

                                    <Resource name="autocomplete/user_clients"/>,
                                    <Resource name="change_password"/>,
                                    <Resource name="export_summary_of_the_day"/>,

                                    hasPermission(permissions, 'base.view_carrierdelivery') ? (
                                        <Resource name="carrier_deliverystates"/>) : null,

                                    hasPermission(permissions, 'distribution.view_reasonstatus') ||
                                    hasPermission(permissions, 'base.view_carrierdelivery') ? (
                                        <Resource
                                            name="reason_status"
                                        />) : null,


                                    // -------- READ ONLY API (CLIENTI)
                                    <Resource name="autocomplete/customer_subjects"/>,
                                    <Resource name="customer_notes"/>,


                                    //OTHER
                                    hasPermission(permissions, 'distribution.change_route') ? (
                                        <Route path='/trackme' component={() => {
                                            window.location.href = 'https://supersonica.be20tet.com';
                                            return null;
                                        }}/>) : null,

                                    (hasPermission(permissions, 'distribution.change_note') || hasPermission(permissions, 'base.view_carrierdelivery')) ? (
                                        <Route path='/ddt_scanner' component={() => {
                                            window.location.href = 'https://www.dropbox.com/scl/fi/w3ei4aep3pafaso745er5/DDTScanner_Supersonica_v2.4.2.zip?rlkey=hs9ntaml7aeq8z50kpqaomm1q&st=q4d98wfw&dl=0';
                                            return null;
                                        }}/>) : null,

                                ];
                            } else {
                                return [
                                    <Resource
                                        icon={HomeIcon}
                                        options={{label: "Homepage"}}
                                        name="home"
                                        list={FirstPage}/>,

                                    hasPermission(permissions, 'distribution.change_note') ? (
                                        <Resource
                                            icon={() => <BsQrCode size={iconSize - 2}/>}
                                            options={{label: "WebScanner"}}
                                            name="qr_scanner"
                                            list={QrScanner}/>) : null,

                                    hasPermission(permissions, 'distribution.change_note') ? (
                                        <Resource
                                            icon={() => <TbRouteScan size={iconSize}/>}
                                            options={{label: "Avvia giro"}}
                                            name="start_route"
                                            list={RouteScanner}/>) : null,

                                    hasPermission(permissions, 'be20_ai.view_convertnote') ? (
                                        <Resource
                                            name="ai_charges"
                                            list={AiChargeDashboard}
                                            options={{label: "Dashboard AI"}}
                                            icon={BarChartIcon}/>) : null,
                                    hasPermission(permissions, 'distribution.change_note') ? (
                                        <Resource name="/routes/qr_code_start_route/"/>) : null,
                                    /*
                                    hasPermission(permissions, 'distribution.change_note') ? (
                                      <Resource
                                        icon={PhotoCameraIcon}
                                        options={{ label: "WebScanner2" }}
                                        name="qr_scanner_2"
                                        list={QrScanner2} />) : null,
                                    */

                                    // ----------------  BUSINESS_INTELLIGENCE
                                    hasPermission(permissions, 'base.show_business_intelligence') ? (
                                        <Resource
                                            icon={BarChartIcon}
                                            options={{label: "BI", isMenuParent: true}}
                                            name="business_intelligence"/>) : null,
                                    hasPermission(permissions, 'base.show_business_intelligence') ? (
                                        <Resource
                                            icon={GroupWorkIcon}
                                            name="delivery_mergers"
                                            list={DeliveryMergerList}
                                            options={{
                                                label: "Analisi pesi/volumi",
                                                menuParent: "business_intelligence"
                                            }}/>) : null,
                                    hasPermission(permissions, 'base.show_business_intelligence') ? (
                                        <Resource
                                            icon={GroupWorkIcon}
                                            name="route_summaries"
                                            list={RouteSummaryList}
                                            options={{
                                                label: "Analisi giri",
                                                menuParent: "business_intelligence"
                                            }}/>) : null,


                                    // ----------------  REGISTRY
                                    hasPermission(permissions, 'registry.view_site') ||
                                    hasPermission(permissions, 'employees.view_employee') ||
                                    hasPermission(permissions, 'fleet_management.view_vehicle') ||
                                    (hasPermission(permissions, 'registry.view_subject') && hasPermission(permissions, 'registry.change_subject')) ? (
                                        <Resource
                                            icon={() => <TfiAgenda size={iconSize}/>}
                                            options={{label: "Anagrafiche", isMenuParent: true}}
                                            name="registry"/>) : null,
                                    hasPermission(permissions, 'registry.view_site') && hasPermission(permissions, 'registry.change_site') ? (
                                        <Resource
                                            icon={StoreIcon}
                                            name="sites"
                                            list={SiteList}
                                            create={SiteCreate}
                                            edit={SiteEdit}
                                            options={{label: "Sedi logistiche", menuParent: "registry"}}/>) : null,
                                    hasPermission(permissions, 'employees.view_employee') ? (
                                        hasPermission(permissions, 'employees.change_employee') ? (
                                            <Resource
                                                icon={SupervisorAccountIcon}
                                                name="employees"
                                                list={EmployeeList}
                                                create={EmployeeCreate}
                                                edit={EmployeeEdit}
                                                options={{label: "Dipendenti", menuParent: "registry"}}/>) : (
                                            <Resource
                                                name="employees"
                                                list={EmployeeList}
                                                options={{label: "Dipendenti", menuParent: "registry"}}/>)
                                    ) : null,


                                    hasPermission(permissions, 'fleet_management.view_vehicle') ? (
                                        <Resource
                                            icon={LocalShippingIcon}
                                            name="vehicles"
                                            list={VehicleList}
                                            create={VehicleCreate}
                                            edit={VehicleEdit}
                                            options={{label: "Veicoli", menuParent: "registry"}}/>) : null,


                                    hasPermission(permissions, 'registry.view_subject') && hasPermission(permissions, 'registry.change_subject') ? (
                                        <Resource
                                            name="subjects"
                                            edit={SubjectEdit}
                                            create={SubjectCreate}
                                            list={SubjectList}
                                            options={{label: "Soggetti", menuParent: "registry"}}
                                            icon={() => <BsPersonVideo2
                                                size={iconSize}/>}/>) : (hasPermission(permissions, 'registry.view_subject') ? (
                                        <Resource
                                            name="subjects"/>) : null),


                                    // ----------------  HR

                                    isAdmin || hasPermission(permissions, "employees.change_workpermit") ? (
                                        <Resource
                                            options={{label: "HR", isMenuParent: true}}
                                            name="hr"
                                            icon={VpnKeyIcon}
                                        />) : null,

                                    hasPermission(permissions, "employees.change_badge") ? (<Resource
                                        options={{label: "Configurazioni", isMenuParent: true, menuParent: "hr"}}
                                        name="hr_conf"
                                        icon={SettingsIcon}
                                    />) : null,

                                    hasPermission(permissions, "employees.change_badge") ? (
                                        <Resource
                                            name="badges"
                                            options={{
                                                label: "Badge", menuParent: "hr_conf",
                                            }}
                                            create={BadgeCreate}
                                            edit={BadgeEdit}
                                            list={BadgeList}
                                            icon={() => <MdOutlineBadge size={iconSize}/>}/>) : null,
                                    hasPermission(permissions, "employees.change_presenceqr") ? (
                                        <Resource
                                            name="presence_qr"
                                            options={{
                                                label: "Qr accessi", menuParent: "hr_conf",
                                            }}
                                            create={PresenceQrCreate}
                                            edit={PresenceQrEdit}
                                            list={PresenceQrList}
                                            icon={() => <BiQrScan size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, "employees.change_presencezone") ? (
                                        <Resource
                                            name="presence_zones"
                                            options={{
                                                label: "Zone timbratura", menuParent: "hr_conf",
                                            }}
                                            edit={PresenceZoneEdit}
                                            list={PresenceZoneList}
                                            icon={() => <TbMapUp size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, "employees.change_workpermittype") ? (
                                        <Resource
                                            name="workpermittypes"
                                            options={{
                                                label: "Tag permessi", menuParent: "hr_conf",
                                            }}
                                            list={WorkPermitTypeList}
                                            create={WorkPermitTypeCreate}
                                            edit={WorkPermitTypeEdit}
                                        />
                                    ) : null,

                                    hasPermission(permissions, "employees.change_presence") ? (<Resource
                                        options={{label: "Presenze", isMenuParent: true, menuParent: "hr"}}
                                        name="hr_presence"
                                        icon={() => <PiListChecksBold size={iconSize}/>}
                                    />) : null,

                                    hasPermission(permissions, "employees.change_presence") ? (
                                        <Resource
                                            name="presences"
                                            options={{
                                                label: "Presenze", menuParent: "hr_presence",
                                            }}
                                            create={PresenceCreate}
                                            edit={PresenceEdit}
                                            list={PresenceList}
                                            icon={AssignmentTurnedInIcon}/>) : null,


                                    hasPermission(permissions, "employees.change_presence") ? (
                                        <Resource
                                            name="presences_day"
                                            options={{
                                                label: "Calendario sett. ", menuParent: "hr_presence",
                                            }}
                                            list={PresenceDayList}
                                            icon={() => <TbCalendarWeekFilled size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, "employees.change_presence") ? (
                                        <Resource
                                            name="presences_calendar"
                                            options={{
                                                label: "Calendario", menuParent: "hr_presence",
                                            }}
                                            list={PresenceCalendar}
                                            icon={() => <BsCalendar2Week size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, "base.change_timesheet") ? (
                                        <Resource
                                            name="presences_calendar_summary"
                                            options={{
                                                label: "Timesheet", menuParent: "hr_presence",
                                            }}
                                            list={PresenceSummary}
                                            icon={() => <PiTableLight size={iconSize}/>}/>) : null,


                                    hasPermission(permissions, "employees.change_presenceqr") ? (
                                        <Resource
                                            name="presence_qr_generator"
                                            options={{
                                                label: "Generatore Qr", menuParent: "hr",
                                            }}
                                            list={PresenceQrGeneratorPage}
                                            icon={SelectAllIcon}/>) : null,

                                    hasPermission(permissions, "employees.change_presence") ? (
                                        <Resource
                                            name="presences_only_in"
                                            options={{
                                                label: "Loggati", menuParent: "hr",
                                            }}
                                            list={PresenceOnlyInList}
                                            icon={AssignmentTurnedInIcon}/>) : null,


                                    (hasPermission(permissions, "base.change_workpermit_c1") ||
                                        hasPermission(permissions, "base.change_workpermit_c2") ||
                                        hasPermission(permissions, "base.change_workpermit_c3")) ? (
                                        <Resource
                                            options={{label: "Permessi", isMenuParent: true, menuParent: "hr"}}
                                            name="workpermits_presence"
                                            icon={() => <FaUmbrellaBeach size={iconSize}/>}
                                        />
                                    ) : null,
                                    (hasPermission(permissions, "base.change_workpermit_c1") ||
                                        hasPermission(permissions, "base.change_workpermit_c2") ||
                                        hasPermission(permissions, "base.change_workpermit_c3")) ? (
                                        <Resource
                                            name="workpermits"
                                            options={{
                                                label: "Permessi", menuParent: "workpermits_presence",
                                            }}
                                            create={WorkPermitCreate}
                                            edit={WorkPermitEdit}
                                            list={WorkPermitList}
                                            icon={() => <FaUmbrellaBeach size={iconSize}/>}/>
                                    ) : null,
                                    (hasPermission(permissions, "base.change_workpermit_c1") ||
                                        hasPermission(permissions, "base.change_workpermit_c2") ||
                                        hasPermission(permissions, "base.change_workpermit_c3")) ? (
                                        <Resource
                                            name="workpermits_calendar"
                                            options={{
                                                label: "Calendario perm.", menuParent: "workpermits_presence",
                                            }}
                                            list={WorkPermitCalendar}
                                            icon={() => <TbCalendarWeekFilled size={iconSize}/>}/>
                                    ) : null,

                                    !(hasPermission(permissions, "base.change_workpermit_c1") ||
                                        hasPermission(permissions, "base.change_workpermit_c2") ||
                                        hasPermission(permissions, "base.change_workpermit_c3")) && hasPermission(permissions, "employees.view_workpermit") ? (
                                        <Resource
                                            name="workpermits"
                                            options={{
                                                label: "Permessi", menuParent: "hr",
                                            }}
                                            create={WorkPermitCreate}
                                            edit={WorkPermitEdit}
                                            list={WorkPermitList}
                                            icon={() => <FaUmbrellaBeach size={iconSize}/>}/>) : null,


                                    (hasPermission(permissions, "base.change_workpermit_c1") ||
                                        hasPermission(permissions, "base.change_workpermit_c2") ||
                                        hasPermission(permissions, "base.change_workpermit_c3"))
                                        ? (
                                            <Resource
                                                name="workpermitrules"
                                                options={{
                                                    label: "Regole Permessi", menuParent: "hr",
                                                }}
                                                create={WorkPermitRuleCreate}
                                                edit={WorkPermitRuleEdit}
                                                list={WorkPermitRuleList}
                                                icon={AssignmentTurnedInIcon}/>) : null,

                                    false && ((hasPermission(permissions, "base.change_workpermit_c1") ||
                                        hasPermission(permissions, "base.change_workpermit_c2") ||
                                        hasPermission(permissions, "base.change_workpermit_c3")))
                                        ? (
                                            <Resource
                                                name="workpermit_totals"
                                                options={{
                                                    label: "Totali Permessi", menuParent: "hr",
                                                }}
                                                list={WorkPermitTotalsList}
                                                icon={AssignmentTurnedInIcon}/>) : null,


                                    false && isAdmin ? (
                                        <Resource
                                            name="shifts_maker"
                                            options={{
                                                label: "Gestione Turni", menuParent: "hr",
                                            }}
                                            list={ShiftsMakerPage}
                                            icon={TuneIcon}/>) : null,
                                    // ----------------  IMPORT
                                    hasPermission(permissions, 'file_import.view_missingsubject') ||
                                    hasPermission(permissions, 'file_import.view_importedfile') ||
                                    hasPermission(permissions, 'file_import.change_importedfile') ? (
                                        <Resource
                                            options={{label: "Import", isMenuParent: true}}
                                            name="import"
                                            icon={() => <FaFileImport size={iconSize}/>}/>) : null,
                                    hasPermission(permissions, 'file_import.view_importedfile') ? (
                                        <Resource
                                            options={{label: "File importati", menuParent: "import"}}
                                            name="imported-files"
                                            list={ImportList}
                                            icon={PlaylistAddCheckIcon}/>) : null,
                                    hasPermission(permissions, 'file_import.change_importedfile') ? (
                                        <Resource
                                            options={{label: "Carica file", menuParent: "import"}}
                                            name="upload"
                                            list={FileUploadList}
                                            create={FileUploadCreate}
                                            icon={() => <FaFileImport size={iconSize}/>}/>) : null,
                                    hasPermission(permissions, 'file_import.view_importfunction') ? (
                                        <Resource
                                            options={{label: "Funzione di import", menuParent: "import"}}
                                            name="import-functions"
                                            list={ImportFunctionList}
                                            create={ImportFunctionCreate}
                                            edit={ImportFunctionEdit}
                                            icon={() => <RiFileSettingsLine size={iconSize}/>}/>) : null,
                                    hasPermission(permissions, 'file_import.view_missingsubject') ? (
                                        <Resource
                                            options={{label: "Soggetti non risolti", menuParent: "import"}}
                                            name="missing-subjects"
                                            list={MissingSubjectList}
                                            icon={() => <FaUserLargeSlash size={iconSize}/>}/>) : null,
                                    hasPermission(permissions, 'file_import.view_missingsubject') ? (
                                        <Resource
                                            name="subjects-solver"
                                            list={SubjectSolverList}
                                            options={{
                                                label: "Risolvi soggetti", menuParent: "import",
                                            }}
                                            icon={GroupAddIcon}/>) : null,

                                    hasPermission(permissions, 'file_import.view_importedfile') ? (
                                        <Resource
                                            name="supersonica_template_import_files"
                                            list={DownloadSupersonicaImportTemplate}
                                            options={{label: "Scarica template", menuParent: "import"}}
                                            icon={InsertDriveFileIcon}/>
                                    ) : null,

                                    // ----------------  DISTRIBUTION
                                    hasPermission(permissions, 'distribution.view_delivery') ||
                                    hasPermission(permissions, 'distribution.view_stock') ||
                                    (hasPermission(permissions, 'route_management.change_route') && hasPermission(permissions, 'distribution.view_segment')) ||
                                    (hasPermission(permissions, 'distribution.view_route') && hasPermission(permissions, 'distribution.view_segment')) ||
                                    hasPermission(permissions, 'distribution.view_deliveryzone') ||
                                    hasPermission(permissions, 'distribution.view_note') ? (
                                        <Resource
                                            options={{label: "Distribuzione", isMenuParent: true}}
                                            name="distribution"
                                            icon={SystemUpdateAltIcon}
                                        />) : null,

                                    hasPermission(permissions, 'distribution.view_delivery') ? (
                                        <Resource
                                            name="deliveries"
                                            list={DeliveryList}
                                            edit={DeliveryEdit}
                                            create={DeliveryCreate}
                                            icon={() => <BsUiChecks size={iconSize}/>}
                                            options={{label: "Missioni", menuParent: "distribution"}}/>) : null,

                                    hasPermission(permissions, 'distribution.view_deliveryadministrativeblock') ? (
                                        <Resource
                                            name="delivery_administrative_block"
                                            list={DeliveryAdministrativeBlockList}
                                            icon={() => <MdBlock size={iconSize}/>}
                                            options={{
                                                label: "Missioni blocco amm.",
                                                menuParent: "distribution"
                                            }}/>) : null,

                                    // hasPermission(permissions, 'distribution.view_delivery') ? (
                                    //   <Resource
                                    //     name="deliveries_to_schedule"
                                    //     list={DeliveryToScheduleList}
                                    //     icon={QueueIcon}
                                    //     options={{ label: "Missioni ricorrenti", menuParent: "distribution" }}
                                    //   />) : null,
                                    /*
                                    hasPermission(permissions, 'distribution.view_stock') ? (
                                      <Resource
                                        name="stocks"
                                        list={DeliveryStockedList}
                                        icon={InboxIcon}
                                        options={{ label: "Giacenze", menuParent: "distribution" }} />) : null,

                                    hasPermission(permissions, 'distribution.view_stock') ? (
                                      <Resource
                                        name="suspends"
                                        list={DeliverySuspendedList}
                                        icon={InboxIcon}
                                        options={{ label: "Sospese", menuParent: "distribution" }} />) : null,
                                    */
                                    hasPermission(permissions, 'route_management.change_route') && hasPermission(permissions, 'distribution.change_delivery') ? (
                                        <Resource
                                            name="planner"
                                            list={RoutePlannerPage}
                                            options={{label: "Pianificatore", menuParent: "distribution"}}
                                            icon={MapIcon}/>) : null,

                                    hasPermission(permissions, 'route_management.change_route') && hasPermission(permissions, 'distribution.change_route') && hasPermission(permissions, 'distribution.change_segment') ? (
                                        <Resource
                                            name="routes"
                                            list={RouteList}
                                            edit={RouteEdit}
                                            options={{label: "Giri", menuParent: "distribution"}}
                                            icon={TimelineIcon}/>) : (hasPermission(permissions, 'distribution.view_route') ? (
                                        <Resource
                                            name="routes"
                                        />) : null),
                                    hasPermission(permissions, 'distribution.view_splitsegment') ? (
                                        <Resource
                                            name="split-segments"
                                            list={SplitSegmentList}
                                            options={{label: "Split eseguiti", menuParent: "distribution"}}
                                            icon={TimelineIcon}/>) : null,

                                    hasPermission(permissions, 'distribution.view_deliveryzone') ? (
                                        <Resource
                                            name="delivery-zones"
                                            options={{
                                                label: "Zone", menuParent: "distribution",
                                            }}
                                            edit={DeliveryZoneEdit}
                                            list={DeliveryZoneList}
                                            icon={EditLocationIcon}/>) : null,

                                    hasPermission(permissions, 'route_management.change_route') && hasPermission(permissions, 'distribution.change_route') && hasPermission(permissions, 'distribution.change_segment') ? (
                                        <Resource
                                            name="delivery-groups"
                                            list={DeliveryGroupList}
                                            edit={DeliveryGroupEdit}
                                            options={{label: "Raggruppamenti", menuParent: "distribution"}}
                                            icon={ListAltIcon}/>) : null,


                                    hasPermission(permissions, 'route_management.change_route') && hasPermission(permissions, 'distribution.change_delivery') ? (
                                        <Resource name="autocomplete/delivery-group"/>) : null,

                                    // ----------------  WAREHOUSE
                                    hasPermission(permissions, 'route_management.view_route') ||
                                    hasPermission(permissions, 'distribution.view_segment') ? (
                                        <Resource
                                            options={{label: "Magazzino", isMenuParent: true}}
                                            name="warehouse"
                                            icon={HomeWorkIcon}/>) : null,

                                    hasPermission(permissions, 'route_management.view_route') ? (
                                        <Resource
                                            name="board_routes"
                                            list={BoardRoutes}
                                            options={{label: "Bacheca giri", menuParent: "warehouse"}}
                                            icon={() => <FaPersonChalkboard size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'route_management.view_route') ? (
                                        <Resource
                                            name="routes-monitor"
                                            list={RouteMonitorList}
                                            options={{label: "Monitoraggio giri", menuParent: "warehouse"}}
                                            icon={() => <LuMonitorCheck size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'route_management.view_route') &&
                                    hasPermission(permissions, 'distribution.view_route') &&
                                    hasPermission(permissions, 'distribution.view_segment') ? (
                                        <Resource
                                            name="load-routes"
                                            list={LoadRouteList}
                                            edit={LoadRouteEdit}
                                            options={{label: "Carica giri", menuParent: "warehouse"}}
                                            icon={() => <FaTruckLoading size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'route_management.view_route') &&
                                    hasPermission(permissions, 'distribution.view_segment') ? (
                                        <Resource
                                            name="load-deliveries"
                                            list={LoadDeliveriesList}
                                            icon={() => <LuPackageCheck size={iconSize}/>}
                                            options={{label: "Carica missioni", menuParent: "warehouse"}}/>) : null,

                                    hasPermission(permissions, 'route_management.view_route') &&
                                    hasPermission(permissions, 'distribution.view_segment') ? (
                                        <Resource
                                            name="summary-of-the-day"
                                            list={PageSummaryOfTheDay}
                                            icon={() => <MdSummarize size={iconSize}/>}
                                            options={{label: "Riassunto giornata", menuParent: "warehouse"}}/>) : null,

                                    hasPermission(permissions, 'distribution.view_note') ?
                                        <Resource
                                        options={{label: "Bolle", isMenuParent: true, beta: true}}
                                        name="note-menu"
                                        icon={InsertDriveFileIcon}
                                        /> : null,
                                    hasPermission(permissions, 'distribution.view_note') ? (
                                        <Resource
                                            name="notes"
                                            list={NoteList}
                                            edit={NoteEdit}
                                            create={NoteCreate}
                                            options={{label: "Bolle", menuParent: "note-menu"}}
                                            icon={InsertDriveFileIcon}/>) : null,

                                    hasPermission(permissions, 'distribution.view_noteimport') ? (
                                        <Resource
                                            name="note-imports"
                                            list={NoteImportList}
                                            options={{label: "Import bolle", menuParent: "note-menu"}}
                                            icon={InsertDriveFileIcon}/>) : null,

                                    hasPermission(permissions, 'distribution.view_noteconfiguration') ? (
                                        <Resource
                                            name="note-configurations"
                                            list={NoteConfigurationList}
                                            create={NoteConfigurationCreate}
                                            edit={NoteConfigurationEdit}
                                            options={{label: "Configurazioni bolle", menuParent: "note-menu"}}
                                            icon={SettingsIcon}/>) : null,

                                    hasPermission(permissions, 'be20_ai.view_convertnote') ? (
                                        <Resource
                                            name="note_convert"
                                            list={NoteConvertPage}
                                            options={{label: "Converti bolle", menuParent: "note-menu"}}
                                            icon={() => <BsStars size={iconSize}/>}/>) : null,

                                    // ----------------  CACHET
                                    hasPermission(permissions, 'cash_on_delivery.display_cachet_to_cash_in') ||
                                    hasPermission(permissions, 'cash_on_delivery.display_cachet_cashed') ||
                                    hasPermission(permissions, 'cash_on_delivery.view_remittance') ||
                                    hasPermission(permissions, 'cash_on_delivery.view_cachet_box') ? (
                                        <Resource
                                            options={{label: "Contrassegni", isMenuParent: true,}}
                                            name="cachets-menu"
                                            icon={() => <GiReceiveMoney size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'cash_on_delivery.display_cachet_to_cash_in') ? (
                                        <Resource
                                            name="cachets"
                                            edit={CachetEdit}
                                            list={CachetToCashInList}
                                            options={{label: "Da incassare", menuParent: "cachets-menu",}}
                                            icon={MoneyOffIcon}/>) : null,

                                    hasPermission(permissions, 'cash_on_delivery.display_cachet_to_cash_in') ?
                                        <Resource name="autocomplete/cachet-boxes"/>
                                        : null,

                                    hasPermission(permissions, 'cash_on_delivery.display_cachet_cashed') ? (
                                        <Resource
                                            name="cachet-payments"
                                            list={CachetPaymentList}
                                            edit={CachetEdit}
                                            options={{label: "Incassi", menuParent: "cachets-menu",}}
                                            icon={AttachMoneyIcon}/>) : null,

                                    hasPermission(permissions, 'cash_on_delivery.display_cachet_cashed') ? (
                                        <Resource
                                            name="cachet-boxes"
                                            list={CachetBoxList}
                                            options={{label: "Casse", menuParent: "cachets-menu",}}
                                            icon={() => <TbCashRegister size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'cash_on_delivery.view_remittance') ? (
                                        <Resource
                                            name="remittances"
                                            list={RemittanceList}
                                            edit={RemittanceEdit}
                                            options={{label: "Rimesse", menuParent: "cachets-menu"}}
                                            icon={TocIcon}
                                        />) : null,


                                    // ----------------  ARTICLES
                                    hasPermission(permissions, 'base.view_accounting_s') ||
                                    hasPermission(permissions, 'base.view_accounting_p') ? (
                                        <Resource
                                            options={{label: "Tariffe", isMenuParent: true}}
                                            name="articles"
                                            icon={() => <TbPackages size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'distribution.view_category') ? (
                                        <Resource
                                            name="categories"
                                            create={CategoryCreate}
                                            list={CategoryList}
                                            edit={CategoryEdit}
                                            options={{label: "Categorie articoli", menuParent: "articles",}}
                                            icon={() => <MdOutlineCategory size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'distribution.view_item') ? (
                                        <Resource
                                            name="items"
                                            create={ItemCreate}
                                            list={ItemList}
                                            edit={ItemEdit}
                                            options={{label: "Articoli", menuParent: "articles",}}
                                            icon={() => <TbPackages size={iconSize}/>}/>) : null,


                                    hasPermission(permissions, 'distribution.view_tariff') ? (
                                        <Resource
                                            name="tariffs"
                                            create={TariffCreate}
                                            edit={TariffEdit}
                                            list={TariffList}
                                            options={{label: "Tariffe", menuParent: "articles",}}
                                            icon={() => <FaMoneyCheckDollar size={iconSize}/>}/>) : null,
                                    /*
                                    hasPermission(permissions, 'distribution.view_tariff') ? (
                                      <Resource
                                  name="grouped_tariffs"
                                  list={GroupedTariffList}
                                  edit={TariffEdit}
                                  options={{ label: "Tariffe/Clienti", menuParent: "articles", }}
                                  icon={LocalAtmIcon} />) : null,
                                */
                                    hasPermission(permissions, 'distribution.change_reasonstatus') && isAdmin ? (
                                        <Resource
                                            name="reason_status"
                                            create={ReasonStatusCreate}
                                            edit={ReasonStatusEdit}
                                            list={ReasonStatusList}
                                            options={{label: "Motivazioni stati", menuParent: "articles",}}
                                            icon={QuestionAnswerIcon}/>
                                    ) : (
                                        hasPermission(permissions, 'distribution.view_reasonstatus') || hasPermission(permissions, 'base.view_carrierdelivery') ? (
                                            <Resource
                                                name="reason_status"
                                            />) : null
                                    ),

                                    // ----------------  ACCOUNTING

                                    hasPermission(permissions, 'base.view_accounting_s') ? (
                                        <Resource
                                            options={{label: "Fatt. Vendita", isMenuParent: true}}
                                            name="accounting"
                                            icon={() => <BsJournalPlus size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'accounting.change_charge') ? (
                                        <Resource
                                            name="charges-summary"
                                            list={ChargesSummaryList}
                                            options={{label: "Tot. valida righe", menuParent: "accounting"}}
                                            icon={AccountTreeIcon}/>) : null,

                                    hasPermission(permissions, 'accounting.change_charge') ? (
                                        <Resource
                                            name="charges"
                                            list={CalculateChargesList}
                                            edit={ChargeEdit}
                                            options={{label: "Valida righe", menuParent: "accounting"}}
                                            icon={AccountTreeIcon}/>) : null,


                                    hasPermission(permissions, 'accounting.change_charge') ? (
                                        <Resource
                                            name="verified-charges-summary"
                                            list={VerifiedChargesSummaryList}
                                            options={{label: "Tot. prefatture", menuParent: "accounting"}}
                                            icon={() => <FaFileInvoice size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'accounting.change_charge') ||
                                    hasPermission(permissions, 'accounting.change_invoice') ? (
                                        <Resource
                                            name="verified-charges"
                                            edit={ChargeEdit}
                                            list={VerifiedChargesList}
                                            options={{label: "Prefattura", menuParent: "accounting"}}
                                            icon={() => <FaFileInvoice size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'accounting.view_invoice') ? (
                                        <Resource
                                            name="invoices"
                                            list={InvoiceList}
                                            show={InvoiceShow}
                                            edit={InvoiceEdit}
                                            create={InvoiceCreate}
                                            options={{label: "Fatture", menuParent: "accounting"}}
                                            icon={() => <FaFileInvoiceDollar size={iconSize}/>}/>) : null,


                                    // ----------------  ACCOUNTING PURCHASE
                                    hasPermission(permissions, 'base.view_accounting_p') ? (
                                        <Resource
                                            options={{label: "Fatt. Passive", isMenuParent: true}}
                                            name="accounting-a"
                                            icon={() => <BsJournalMinus size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'accounting.change_charge') ? (
                                        <Resource
                                            name="charges-summary-a"
                                            list={PurchaseChargesSummaryList}
                                            options={{label: "Tot. valida righe P.", menuParent: "accounting-a"}}
                                            icon={AccountTreeIcon}/>) : null,

                                    hasPermission(permissions, 'accounting.change_charge') ? (
                                        <Resource
                                            name="charges-a"
                                            list={CalculatePurchaseChargesList}
                                            options={{label: "Valida righe P.", menuParent: "accounting-a"}}
                                            icon={AccountTreeIcon}/>) : null,

                                    hasPermission(permissions, 'accounting.change_charge') ? (
                                        <Resource
                                            name="verified-charges-summary-a"
                                            list={VerifiedPurchaseChargesSummaryList}
                                            options={{label: "Tot. prefatture P.", menuParent: "accounting-a"}}
                                            icon={() => <FaFileInvoice size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'accounting.change_charge') ||
                                    hasPermission(permissions, 'accounting.change_invoice') ? (
                                        <Resource
                                            name="verified-charges-a"
                                            edit={PurchaseChargeEdit}
                                            list={VerifiedPurchaseChargesList}
                                            options={{label: "Prefattura P.", menuParent: "accounting-a"}}
                                            icon={() => <FaFileInvoice size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'accounting.view_invoice') ? (
                                        <Resource
                                            name="invoices-a"
                                            list={PurchaseInvoiceList}
                                            show={InvoiceShow}
                                            edit={InvoiceEdit}
                                            create={PurchaseInvoiceCreate}
                                            options={{label: "Fatture P.", menuParent: "accounting-a"}}
                                            icon={() => <FaFileInvoiceDollar size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'accounting.view_invoice') ? (
                                        <Resource
                                            name="approved_invoices"
                                            list={ApprovedInvoicesList}
                                            options={{label: "Approva fatture", menuParent: "accounting-a"}}
                                            icon={() => <MdDomainVerification size={iconSize}/>}/>) : null,


                                    hasPermission(permissions, 'accounting.view_invoice') ? (
                                        <Resource
                                            name="document"
                                            list={DocumentList}
                                            edit={DocumentEdit}
                                            create={DocumentCreate}
                                            options={{label: "Documenti", menuParent: "accounting-a"}}
                                            icon={() => <IoDocuments size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'accounting.change_invoice') ? (
                                        <Resource
                                            options={{label: "XML", menuParent: "accounting-a"}}
                                            name="xml_invoices_imports"
                                            list={XMLFileUploadList}
                                            create={XMLFileUploadCreate}
                                            icon={PublishIcon}/>) : null,

                                    isAdmin ? (
                                        <Resource
                                            icon={() => <GoCodescanCheckmark size={iconSize}/>}
                                            options={{label: "Verifica contatore"}}
                                            name="check_counter"
                                            list={CheckCounter}/>) : null,

                                    // ----------------  ACCOUNTING CHART ACCOUNTS

                                    hasPermission(permissions, 'base.view_accounting_p') ? (
                                        <Resource
                                            options={{label: "Piano dei conti", isMenuParent: true}}
                                            name="chartofaccounts"
                                            icon={() => <GiFamilyTree size={iconSize}/>}/>) : null,


                                    hasPermission(permissions, 'accounting.view_invoicechartaccounts') ? (
                                        <Resource
                                            name="invoicechartaccounts"
                                            list={InvoiceChartAccountsGroupedList}
                                            options={{label: "Resoconto", menuParent: "chartofaccounts",}}
                                            icon={() => <TbReportMoney size={iconSize}/>}/>) : null,


                                    hasPermission(permissions, 'accounting.change_chartaccounts') ? (
                                        <Resource
                                            name="chartaccounts"
                                            list={ChartAccountsList}
                                            create={ChartAccountsCreate}
                                            edit={ChartAccountsEdit}
                                            options={{label: "Categorie Lista", menuParent: "chartofaccounts"}}
                                            icon={() => <TbListLetters size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'accounting.change_chartaccounts') ? (
                                        <Resource
                                            icon={AccountTreeIcon}
                                            options={{label: "Categorie Albero", menuParent: "chartofaccounts",}}
                                            name="cartegories_tree"
                                            list={ChartAccountsTreePage}/>) : null,


                                    hasPermission(permissions, 'accounting.change_chartaccountstag') ? (
                                        <Resource
                                            name="chartaccountstags"
                                            list={ChartAccountsTagsList}
                                            create={ChartAccountsTagsCreate}
                                            edit={ChartAccountsTagsEdit}
                                            options={{label: "Tags", menuParent: "chartofaccounts"}}
                                            icon={MoreIcon}/>) : null,


                                    (
                                        hasPermission(permissions, 'accounting.view_paymentschedule') ||
                                        hasPermission(permissions, 'accounting.view_bankreceipt') ||
                                        hasPermission(permissions, 'accounting.view_journalentry') ||
                                        hasPermission(permissions, 'accounting.view_reconciliationfile') ||
                                        hasPermission(permissions, 'accounting.view_reconciliation') ||
                                        hasPermission(permissions, 'accounting.view_invoice')
                                    ) ? (
                                        <Resource
                                            options={{label: "Incassi/Pagamenti", isMenuParent: true}}
                                            name="collect-payments"
                                            icon={() => <MdOutlineAccountBalance size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'accounting.view_paymentschedule') ? (
                                        <Resource
                                            name="payment_schedule"
                                            list={PaymentScheduleList}
                                            edit={PaymentScheduleEdit}
                                            options={{label: "Scadenzario", menuParent: "collect-payments",}}
                                            icon={() => <IoIosTimer size={iconSize}/>}/>) : null,

                                    user.is_admin ? (
                                        <Resource
                                            name="payment_schedule_status"
                                            edit={PaymentScheduleStatusEdit}
                                            />) : null,

                                    hasPermission(permissions, 'accounting.view_bankreceipt') ? (
                                        <Resource
                                            name="bank_receipt"
                                            list={BankReceiptList}
                                            create={BankReceiptCreate}
                                            edit={BankReceiptEdit}
                                            options={{label: "Ri.Ba.", menuParent: "collect-payments",}}
                                            icon={() => <MdPayments size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'accounting.view_journalentry') ? (
                                        <Resource
                                            name="journal_entry"
                                            list={JournalEntryList}
                                            create={JournalEntryCreate}
                                            edit={JournalEntryEdit}
                                            options={{label: "Prima nota", menuParent: "collect-payments",}}
                                            icon={AttachMoneyIcon}/>) : null,
                                    hasPermission(permissions, 'accounting.view_reconciliationfile') ? (
                                        <Resource
                                            name="reconciliation_file"
                                            list={ReconciliationFileList}
                                            create={ReconciliationFileCreate}
                                            options={{label: "File riconciliazione", menuParent: "collect-payments",}}
                                            icon={() => <TbFileTypeXml size={iconSize}/>}/>) : null,
                                    hasPermission(permissions, 'accounting.view_reconciliation') ? (
                                        <Resource
                                            name="reconciliation"
                                            list={ReconciliationList}
                                            options={{label: "Riconciliazione", menuParent: "collect-payments",}}
                                            icon={() => <LuTableColumnsSplit size={iconSize}/>}/>) : null,
                                    hasPermission(permissions, 'base.show_debt_collection') ? (
                                        <Resource
                                            name="debt_collection"
                                            list={DebtColletionList}
                                            show={DebtColletionShow}
                                            options={{label: "Recupero crediti", menuParent: "collect-payments",}}
                                            icon={() => <FaMoneyBillTransfer size={iconSize}/>}/>) : null,

                                    // ----------------  CUSTOMERS PORTAL
                                    hasPermission(permissions, 'auth.view_user') ||
                                    hasPermission(permissions, 'customers.view_customersubject') ||
                                    hasPermission(permissions, 'base.view_deliverytracking') ||
                                    hasPermission(permissions, 'customers.view_customerorder') ? (
                                        <Resource
                                            options={{label: "Portale Clienti", isMenuParent: true}}
                                            name="customer_portal"
                                            icon={() => <FaRegHandshake size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'customers.view_customersubject') ? (
                                        <Resource
                                            name="customer_subjects"
                                            list={CustomerSubjectList}
                                            edit={CustomerSubjectEdit}
                                            create={CustomerSubjectCreate}
                                            options={{label: "Anagrafica", menuParent: "customer_portal"}}
                                            icon={PermContactCalendarIcon}/>) : null,

                                    hasPermission(permissions, 'base.view_deliverytracking') ? (
                                        <Resource
                                            name="customer_deliveries"
                                            list={CustomerDeliveryList}
                                            options={{label: "Tracking", menuParent: "customer_portal"}}
                                            icon={() => <GiGps size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'customers.view_customerorder') ? (
                                        <Resource
                                            name="customer_orders"
                                            list={CustomerOrderList}
                                            edit={CustomerOrderEdit}
                                            create={CustomerOrderCreate}
                                            options={{label: "Ordini", menuParent: "customer_portal"}}
                                            icon={() => <BsUiChecks size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'customers.view_customerorder') ? (
                                        <Resource
                                            name="customer_import_files"
                                            create={CustomerImportFileCreate}
                                            list={CustomerImportFileList}
                                            options={{label: "Importa file", menuParent: "customer_portal"}}
                                            icon={PublishIcon}/>) : null,

                                    hasPermission(permissions, 'customers.view_customerorder') ? (
                                        <Resource
                                            name="customer_template_import_files"
                                            list={DownloadCustomerImportTemplate}
                                            options={{label: "Scarica template", menuParent: "customer_portal"}}
                                            icon={InsertDriveFileIcon}/>
                                    ) : null,

                                    hasPermission(permissions, 'auth.view_user') ? (
                                        <Resource
                                            name="user_clients"
                                            list={UserClientList}
                                            create={UserClientCreate}
                                            edit={UserClientEdit}
                                            options={{label: "Utenti", menuParent: "customer_portal"}}
                                            icon={() => <FaRegUser size={iconSize}/>}/>) : null,

                                    // ----------------  CARRIER PORTAL
                                    hasPermission(permissions, 'base.view_carrierdelivery') || hasPermission(permissions, 'auth.view_user') ? (
                                        <Resource
                                            options={{label: "Portale Corrieri", isMenuParent: true}}
                                            name="carrier_portal"
                                            icon={() => <FaPeopleCarryBox size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'base.view_carrierdelivery') ? (
                                        <Resource
                                            name="carrier_deliveries"
                                            list={CarrierDeliveryList}
                                            options={{label: "Missioni", menuParent: "carrier_portal"}}
                                            icon={() => <BsUiChecks size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'base.view_carrierdelivery') ? (
                                        <Resource
                                            name="carrier_borderaux"
                                            list={CarrierBorderauxList}
                                            options={{label: "Borderaux", menuParent: "carrier_portal"}}
                                            icon={() => <IoIosListBox size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'base.view_carrierdelivery') ? (
                                        <Resource
                                            name="carrier_routes"
                                            list={CarrierRouteList}
                                            options={{label: "Giri", menuParent: "carrier_portal"}}
                                            icon={() => <IoIosListBox size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'carriers.view_carriercashbox') ? (
                                        <Resource
                                            name="carrier_cashboxes"
                                            list={CarrierCashBoxList}
                                            options={{label: "Casse", menuParent: "carrier_portal"}}
                                            icon={() => <TbCashRegister size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'auth.view_user') ? (
                                        <Resource
                                            name="user_carriers"
                                            list={UserCarrierList}
                                            create={UserCarrierCreate}
                                            edit={UserCarrierEdit}
                                            options={{label: "Utenti", menuParent: "carrier_portal"}}
                                            icon={() => <FaRegUser size={iconSize}/>}/>) : null,


                                    // ----------------  FORKLIFT
                                    isAdmin ? (
                                        <Resource
                                            options={{label: "4.0", isMenuParent: true}}
                                            name="interconnections"
                                            icon={AllInboxIcon}/>) : null,

                                    isAdmin ? (
                                        <Resource
                                            name="forklifts"
                                            list={ForkliftList}
                                            options={{label: "Muletti", menuParent: "interconnections",}}
                                            icon={() => <MdForklift size={iconSize}/>}/>) : null,

                                    isAdmin ? (
                                        <Resource name="forklift"/>
                                    ) : null,

                                    // ----------------  ADMIN
                                    isAdmin || hasPermission(permissions, 'auth.change_user') ? (
                                        <Resource
                                            options={{label: "Admin", isMenuParent: true}}
                                            name="email-handlers"
                                            icon={() => <GrConfigure size={iconSize}/>}/>) : null,

                                    hasPermission(permissions, 'auth.change_user') ? (
                                        <Resource
                                            name="users"
                                            list={UsersList}
                                            create={UserCreate}
                                            edit={UserEdit}
                                            options={{label: "Utenti", menuParent: "email-handlers",}}
                                            icon={() => <FaRegUser size={iconSize}/>}/>) : null,

                                    isAdmin ? (
                                        <Resource
                                            name="configs"
                                            list={EtaConfigPage}
                                            options={{label: "Config. ETA", menuParent: "email-handlers"}}
                                            icon={TuneIcon}/>) : null,


                                    isAdmin ? (
                                        <Resource
                                            name="emails"
                                            list={EmailList}
                                            options={{label: "Email", menuParent: "email-handlers",}}
                                            icon={() => <MdOutlineMailOutline size={iconSize}/>}/>) : null,

                                    isAdmin ? (
                                        <Resource
                                            icon={() => <LuFolderTree size={iconSize}/>}
                                            options={{label: "Info permessi", menuParent: "email-handlers",}}
                                            name="permission_info"
                                            list={PermissionInfoPage}/>) : null,
                                    isAdmin ? (
                                        <Resource
                                            icon={() => <FaTags size={iconSize}/>}
                                            options={{label: "Tag giri", menuParent: "email-handlers",}}
                                            name="tag"
                                            list={TagList}
                                            create={TagCreate}
                                            edit={TagEdit}
                                        />) : null,

                                    isAdmin ? (
                                        <Resource
                                            icon={() => <IoChatbubbleEllipsesSharp size={iconSize}/>}
                                            options={{label: "Notifiche chat id", menuParent: "email-handlers",}}
                                            name="notification_chat_id"
                                            list={NotificationChatIdList}
                                            edit={NotificationChatIdEdit}
                                        />) : null,

                                    <Resource
                                        icon={() => <BsInfoCircle size={iconSize}/>}
                                        options={{label: "Info"}}
                                        name="info"
                                        list={InfoPage}/>,


                                    // -------- READ ONLY API
                                    // TODO: Ricordarsi di inserire dei permessi più robusti
                                    hasPermission(permissions, 'route_management.change_route') ? (
                                        <Resource name="route_maps"/>) : null,
                                    hasPermission(permissions, 'distribution.view_deliveryattachment') ? (
                                        <Resource name="delivery_attachments"/>) : null,
                                    hasPermission(permissions, 'registry.view_subjectattachment') ? (
                                        <Resource name="subject_attachments"/>) : null,
                                    <Resource name="delivery-items"/>,
                                    <Resource name="delivery-note-rows"/>,
                                    <Resource name="invoice-lines"/>,
                                    <Resource name="clients"/>,
                                    <Resource name="deliveries-plan"/>,
                                    <Resource name="segments"/>,
                                    <Resource name="payment-terms"/>,
                                    //<Resource name="invoice-payment-status" />,
                                    <Resource name="delivery-states"/>,
                                    <Resource name="provinces"/>,
                                    <Resource name="sub-tariffs"/>,
                                    <Resource name="notifications"/>,
                                    <Resource name="subjectopenings"/>,
                                    <Resource name="payment_schedule_status"/>,
                                    <Resource name="autocomplete/payment_schedule"/>,
                                    <Resource name="autocomplete/category_document"/>,
                                    <Resource name="autocomplete/journal-category"/>,
                                    <Resource name="autocomplete/group"/>,
                                    <Resource name="file_row"/>,
                                    <Resource name="reconciliation_journal_entry"/>,


                                    <Resource name="autocomplete/user"/>,
                                    <Resource name="autocomplete/delivery"/>,
                                    <Resource name="autocomplete/main_delivery"/>,
                                    <Resource name="autocomplete/subject"/>,
                                    <Resource name="autocomplete/user"/>,
                                    <Resource name="autocomplete/terms-payment"/>,
                                    <Resource name="autocomplete/terms-description"/>,
                                    <Resource name="autocomplete/route"/>,
                                    <Resource name="autocomplete/employee"/>,
                                    <Resource name="autocomplete/vehicle"/>,
                                    <Resource name="autocomplete/site"/>,
                                    <Resource name="autocomplete/imported-files"/>,
                                    <Resource name="autocomplete/delivery-zones"/>,
                                    <Resource name="autocomplete/province"/>,
                                    <Resource name="autocomplete/region"/>,
                                    <Resource name="autocomplete/province-region"/>,
                                    <Resource name="autocomplete/category"/>,
                                    <Resource name="autocomplete/item"/>,
                                    <Resource name="autocomplete/tag"/>,
                                    <Resource name="autocomplete/department"/>,
                                    <Resource name="autocomplete/invoice"/>,
                                    <Resource name="autocomplete/bank"/>,
                                    <Resource name="autocomplete/remittances"/>,
                                    <Resource name="autocomplete/accountcompany"/>,
                                    <Resource name="accountcompany"/>,
                                    <Resource name="tariffs-client"/>,
                                    <Resource name="recipient-notifications"/>,
                                    <Resource name="customer_order_tariffs"/>,
                                    <Resource name="customer_order_items"/>,
                                    <Resource name="tariffs-clone-option"/>,
                                    <Resource name="autocomplete/chartaccounts"/>,
                                    <Resource name="autocomplete/workpermittype"/>,
                                    <Resource name="autocomplete/workpermittypeemployee"/>,
                                    <Resource name="autocomplete/refusereason"/>,
                                    <Resource name="autocomplete/group"/>,
                                    <Resource name="autocomplete/carrier_cashboxes"/>,
                                    <Resource name="autocomplete/user_clients"/>,
                                    <Resource name="change_password"/>,
                                    <Resource name="export_summary_of_the_day"/>,

                                    hasPermission(permissions, 'base.view_carrierdelivery') ? (
                                        <Resource name="carrier_deliverystates"/>) : null,


                                    // -------- READ ONLY API (CLIENTI)
                                    <Resource name="autocomplete/customer_subjects"/>,
                                    <Resource name="customer_notes"/>,


                                    //OTHER
                                    hasPermission(permissions, 'distribution.change_route') ? (
                                        <Route path='/trackme' component={() => {
                                            window.location.href = 'https://supersonica.be20tet.com';
                                            return null;
                                        }}/>) : null,

                                    (hasPermission(permissions, 'distribution.change_note') || hasPermission(permissions, 'base.view_carrierdelivery')) ? (
                                        <Route path='/ddt_scanner' component={() => {
                                            window.location.href = 'https://www.dropbox.com/scl/fi/w3ei4aep3pafaso745er5/DDTScanner_Supersonica_v2.4.2.zip?rlkey=hs9ntaml7aeq8z50kpqaomm1q&st=q4d98wfw&dl=0';
                                            return null;
                                        }}/>) : null,

                                ];
                            }
                        }
                    }
                </Admin>
            </QueryClientProvider>
        </MuiPickersUtilsProvider>
    );
}

export default App;
